import cx from 'classnames'

import Styles from './PropertySearch.module.scss'

interface Props {
  className: string
  placeholder?: string
  query: string
  iconVisible?: boolean
  onCancel: () => void
  onChange: (value: string) => void
  onEnter?: () => void
  autoFocus?: boolean
}

export const PropertySearch = ({
  className,
  placeholder,
  query,
  iconVisible,
  onCancel,
  onChange,
  onEnter,
  autoFocus = false,
}: Props) => (
  <input
    autoFocus={autoFocus}
    key="search"
    className={cx(className, Styles.search)}
    placeholder={placeholder}
    type="text"
    value={query}
    onChange={(e) => onChange(e.target.value)}
    onKeyDown={(event) => {
      if (event.key === 'Escape') {
        onCancel()
      }

      if (event.key === 'Enter' && onEnter) {
        onEnter()
      }
    }}
  />
)
